import {FormatMoney, Tabs} from '../../utilities';
export function init() {
  const formatMoney = new FormatMoney();
  const tabs = new Tabs();

  formatMoney.init();
  tabs.init();
};



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/views/home.js